export default __webpack_public_path__ + "static/media/MateriNavPointImg.f3375875.png";